module.exports = __webpack_public_path__ + "assets/img/14_1066_big.fa0f3110.jpg";